/* tslint:disable */
import * as React from 'react';
/* tslint:enable */
import {
  Persona,
  PersonaPresence,
  PersonaSize,
  IPersonaProps
} from 'office-ui-fabric-react/lib/Persona';
import {
  IPerson, EntityType
} from '@ms/odsp-datasources/lib/PeoplePicker';
import { IPickerItemProps } from 'office-ui-fabric-react/lib/Pickers';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import './PickerItem.scss';

function convertIPersonToIPersonaProps(person: IPerson): IPersonaProps {
  return {
    primaryText: person.name ? person.name : '',
    imageUrl: person.image ? person.image : '',
    tertiaryText: person.email ? person.email : '',
    secondaryText: person.job ? person.job : '',
    imageInitials: '',
    imageAlt: person.imageAlt
  };
}

export const SuggestionItemDefault: (person: IPerson) => JSX.Element = (person: IPerson) => {
  let personaProps: IPersonaProps = convertIPersonToIPersonaProps(person);
  return (
    <div className='ms-PeoplePicker-personaContent'>
      <Persona
        { ...personaProps }
        presence={ PersonaPresence.none }
        size={ PersonaSize.small }
        className={ 'ms-PeoplePicker-pickerPersona' }
      />
      { person.entityType === EntityType.linkedinUser &&
        <Icon
          className={ 'od-PeoplePicker-linkedInLogo' }
          iconName='LinkedInLogo'
        />
      }
    </div>
  );
};

export const SelectedItemDefault: (props: IPickerItemProps<IPerson>) => JSX.Element = (props: IPickerItemProps<IPerson>) => {
  let {
    item,
    onRemoveItem,
    index,
    selected,
    removeButtonAriaLabel
  } = props;
  let personaProps: IPersonaProps = convertIPersonToIPersonaProps(item);
  return (
    <div
      className={ css('ms-PickerPersona-container', {
        'is-selected': !!selected
      }) }
      data-is-focusable={ true }
      data-selection-index={ index }
      key={ index }
      role='listitem'
    >
      <div className='ms-PickerItem-content'>
        <Persona
          { ...personaProps }
          presence={ PersonaPresence.none }
          size={ PersonaSize.extraSmall }
        />
      </div>
      <IconButton
        onClick={ onRemoveItem }
        iconProps={ { iconName: 'Cancel' } }
        className='ms-PickerItem-content'
        data-is-focusable={ false }
        ariaLabel={ removeButtonAriaLabel }
      />
    </div >
  );
};

export const SelectedItemBelowDefault: (props: IPickerItemProps<IPerson>) => JSX.Element = (props: IPickerItemProps<IPerson>) => {
  let {
    item,
    onRemoveItem,
    index,
    selected
  } = props;
  let personaProps: IPersonaProps = convertIPersonToIPersonaProps(item);
  return (
    <div
      className={ css('ms-PickerPersona-container is-listbelow', {
        'is-selected': !!selected
      }) }
      data-is-focusable={ true }
      data-selection-index={ index }
      key={ index }
    >
      <div className='ms-PickerPersona-content'>
        <Persona
          { ...personaProps }
          presence={ PersonaPresence.none }
          size={ PersonaSize.small }
        />
      </div>
      <div className='ms-PickerItem-sideContent'>
        <IconButton
          onClick={ onRemoveItem }
          iconProps={ { iconName: 'Cancel' } }
          className='ms-PickerItem-content'
          data-is-focusable={ false }
        />
      </div>
    </div >
  );
};

export const SelectedItemBelowCustomMenu: (props: IPickerItemProps<IPerson>, menu?: JSX.Element) => JSX.Element =
  (props: IPickerItemProps<IPerson>, menu?: JSX.Element) => {
    let {
      item,
      onRemoveItem,
      index,
      selected
    } = props;
    let personaProps: IPersonaProps = convertIPersonToIPersonaProps(item);
    return (
      <div
        className={ css('ms-PickerPersona-container is-listbelow', {
          'is-selected': !!selected
        }) }
        data-is-focusable={ true }
        data-selection-index={ index }
        key={ index }
      >
        <div className='ms-PickerPersona-content'>
          <Persona
            { ...personaProps }
            presence={ PersonaPresence.none }
            size={ PersonaSize.small }
          >
            { (menu ? menu : (null)) }
          </Persona>
        </div>
        <div className='ms-PickerItem-sideContent'>
          <IconButton
            onClick={ onRemoveItem }
            iconProps={ { iconName: 'Cancel' } }
            className='ms-PickerItem-content'
            data-is-focusable={ false }
          />
        </div>
      </div >
    );
  };